import React from 'react';

/**
 * Renders theme `question_image` as a graphic with the question string overlaid
 * (centered in the bubble area). Used across day games for a consistent layout.
 */
export default function DayQuestionPanel({
  imageUrl,
  question,
  className = '',
  textWrapClassName = '',
  textClassName = '',
}) {
  const q = String(question ?? '').trim();
  const img = String(imageUrl ?? '').trim();
  if (!img && !q) return null;

  return (
    <div className={`day-question-panel ${className}`.trim()}>
      {img ? (
        <img src={img} alt="" className="day-question-panel__bg" />
      ) : (
        <div className="day-question-panel__fallback" aria-hidden />
      )}
      {q ? (
        <div className={`day-question-panel__text-wrap ${textWrapClassName}`.trim()}>
          <p className={`day-question-panel__text ${textClassName}`.trim()}>{q}</p>
        </div>
      ) : null}
    </div>
  );
}
